const houseTrailers = [
  {
    model: "TH450 PLATEAU",
    cargo_dimensions: "450 x 244 x 62 CM",
    total_length: "600 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "500 KG",
    loading_capacity: "3000 KG",
    price: 3950,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH450.jpg",
    imgAlt: "tiny house trailer",
  },
  {
    model: "TH540 PLATEAU",
    cargo_dimensions: "540 x 244 x 62 CM",
    total_length: "690 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "570 KG",
    loading_capacity: "2930 KG",
    price: 4100,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH540.jpg",
    imgAlt: "tiny house trailer",
  },
  {
    model: "TH600 PLATEAU",
    cargo_dimensions: "600 x 244 x 62 CM",
    total_length: "750 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "600 KG",
    loading_capacity: "2900 KG",
    price: 4200,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH600.jpg",
    imgAlt: "remorca pentru casuta mobila",
  },
  {
    model: "TH660 PLATEAU",
    cargo_dimensions: "660 x 244 x 62 CM",
    total_length: "810 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "620 KG",
    loading_capacity: "2880 KG",
    price: 4300,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH660.jpg",
    imgAlt: "remorca pentru tiny house",
  },
  {
    model: "TH720 PLATEAU",
    cargo_dimensions: "720 x 244 x 62 CM",
    total_length: "870 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "650 KG",
    loading_capacity: "2850 KG",
    price: 4400,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH720.jpg",
    imgAlt: "remorci tiny house",
  },
  {
    model: "TH720 PLATEAU",
    cargo_dimensions: "720 x 244 x 63 CM",
    total_length: "870 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "690 KG",
    loading_capacity: "2810 KG",
    price: 4650,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH720 - 3axles.jpg",
    imgAlt: "trailer for tiny house",
  },
  {
    model: "TH720 PLATEAU",
    cargo_dimensions: "720 x 244 x 64 CM",
    total_length: "870 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "780 KG",
    loading_capacity: "2720 KG",
    price: 4950,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH720 - 3axles.jpg",
    imgAlt: "platforma casuta mobila",
  },
  {
    model: "TH780 PLATEAU",
    cargo_dimensions: "780 x 244 x 62 CM",
    total_length: "930 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "680 KG",
    loading_capacity: "2820 KG",
    price: 4500,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH780.jpg",
    imgAlt: "remorci causta mobila",
  },
  {
    model: "TH780 PLATEAU",
    cargo_dimensions: "780 x 244 x 63 CM",
    total_length: "930 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "720 KG",
    loading_capacity: "2780 KG",
    price: 4750,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH780 - 3xles.jpg",
    imgAlt: "trailer pentru casuta mobila",
  },
  {
    model: "TH780 PLATEAU",
    cargo_dimensions: "780 x 244 x 64 CM",
    total_length: "930 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "800 KG",
    loading_capacity: "2700 KG",
    price: 5050,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH780 - 3xles.jpg",
    imgAlt: "casa pe roti",
  },
  {
    model: "TH840 PLATEAU",
    cargo_dimensions: "840 x 244 x 62 CM",
    total_length: "990 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "700 KG",
    loading_capacity: "2800 KG",
    price: 4650,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH840.jpg",
    imgAlt: "remorca casa",
  },    
  {
    model: "TH840 PLATEAU",
    cargo_dimensions: "840 x 244 x 63 CM",
    total_length: "990 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "740 KG",
    loading_capacity: "2760 KG",
    price: 4950,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH840 - 3axles.jpg",
    imgAlt: "trailer pentru tiny house",
  },
  {
    model: "TH840 PLATEAU",
    cargo_dimensions: "840 x 244 x 64 CM",
    total_length: "990 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "820 KG",
    loading_capacity: "2680 KG",
    price: 5250,
    newPrice: null,
    img: "images/tiny-house-trailers-2025/TH840 - 3axles.jpg",
    imgAlt: "trailer pentru tiny house",
  }
];

export default houseTrailers;
